export class OrdenImpresionRequest {
    public Dni: string;
    public NroContratoFinanciero: string;
    public Cliente: string;
    public Correo: string;
    public Sede: string;
    public FinanciamientoId: string;
    public FechaVenta: Date;
    public DireccionCliente: string;
    public NroBoleta: string;
    public RepresentanteNombre: string;
    public RepresentanteDni: string;
    public RepresentanteParentezco: string;
    public Horario: number;
    public Referencia: string;
    public SedeRecojo: string;
    public FechaRecojo: Date;
    public Productos: FinanciamientoDetalleOFV[];
    public Consentimiento: boolean;
    public NroCuota: number;
    public TipoReporte : number;
}

export class FinanciamientoDetalleOFV {
    public IdProducto: number;
    public CantidadProducto: number;
    public PrecioProducto : number;
    public IdAliadoComercial : number;
    public NombreProducto : string
}
export class PagoMensualRequest {
    public Monto : number ;
    public NroCuotas : number ;
}
	 
export class TipoDocumentos {
    public Nombre : string ;
    public Valor : number ;
    public NombreDocumento :string ;
}
